"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupNextBlock = exports.fixationOnly = exports.setupStimulusFromCurrentCatBlock = exports.setupStimulusFromBlock = exports.setupDownex = exports.setupStimulusFromStoryGroup = exports.setupStimulus = exports.setupPractice = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const helpers_1 = require("../helpers");
const taskStore_1 = require("../../../taskStore");
const taskSetup_1 = require("../../taskSetup");
// choosing the next stimulus from the corpus occurs during the fixation trial
// prior to the actual display of the stimulus, where user response is collected
// the array allows us to use the same structure for all corpuses
const fixationTrial = (corpusType, blockNum) => {
    return {
        type: plugin_html_multi_response_1.default,
        stimulus: `<div id='lev-fixation-container'><p>+</p></div>`,
        prompt: '',
        choices: 'NO_KEYS',
        trial_duration: 350,
        data: {
            task: 'fixation',
        },
        on_finish: () => {
            if (corpusType && !(0, helpers_1.shouldUseClowder)()) {
                if (blockNum != undefined) {
                    (0, helpers_1.getStimulus)(corpusType, blockNum);
                }
                else {
                    (0, helpers_1.getStimulus)(corpusType);
                }
            }
        },
    };
};
function assignNextBlock() {
    const thresholds = (0, taskStore_1.taskStore)().blockThresholds;
    const nextBlockThreshold = thresholds.shift();
    let nextBlock = (0, taskStore_1.taskStore)().currentCatBlock;
    if (nextBlockThreshold && taskSetup_1.cat.theta >= nextBlockThreshold) {
        nextBlock++;
    }
    (0, taskStore_1.taskStore)('currentCatBlock', nextBlock);
    (0, taskStore_1.taskStore)('blockThresholds', thresholds);
}
function selectFromCurrentCatBlock() {
    const currentCatBlock = (0, taskStore_1.taskStore)().currentCatBlock;
    (0, helpers_1.getStimulus)('stimulus', currentCatBlock);
}
function selectFromStoryGroup() {
    const currentStoryGroup = (0, taskStore_1.taskStore)().currentStoryGroup;
    (0, helpers_1.getStimulus)('stimulus', undefined, currentStoryGroup, true);
}
exports.setupPractice = fixationTrial('practice');
exports.setupStimulus = fixationTrial('stimulus');
exports.setupStimulusFromStoryGroup = { ...fixationTrial(), on_finish: selectFromStoryGroup, stimulus: '' };
exports.setupDownex = fixationTrial('downex');
const setupStimulusFromBlock = (blockNum) => fixationTrial('stimulus', blockNum);
exports.setupStimulusFromBlock = setupStimulusFromBlock;
exports.setupStimulusFromCurrentCatBlock = {
    ...fixationTrial(),
    on_finish: selectFromCurrentCatBlock,
    stimulus: '',
};
exports.fixationOnly = fixationTrial();
exports.setupNextBlock = { ...fixationTrial(), on_finish: assignNextBlock, stimulus: '' };
